// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './lang'
import validationRules from './form-validations'
import searchCountry from './search-country'
import { store } from './store'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import Axios from 'axios'
import pako from 'pako';
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import '@mdi/font/css/materialdesignicons.css'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import LoginComponent from './components/login.component'
import ForgotPasswordComponent from './components/forgotPassword.component'
import UsersComponent from './components/users.component'
import UserApplicationComponent from './components/user.application.component'
import ExpensesComponent from './components/expenses.component'
import ExpenseItemComponent from './components/expense.item.component'
import ExpenseTrackingItemComponent from './components/expenseTracking.item.component'
import CategoriesComponent from './components/categories.component'
import TravelTypesComponent from './components/travelTypes.component'
import AreasComponent from './components/areas.component'
import ToReconcileExpensesComponent from './components/toReconcileExpenses.component'
import ReconciledExpensesComponent from './components/reconciledExpenses.component'
import MissingExpensesComponent from './components/missingExpenses.component'
import ExcludedExpensesComponent from './components/excludedExpenses.component'
import SettingsComponent from './components/settings.component'
import ValidatorsComponent from './components/validators.component'
import ApproverComponent from './components/approver.component'
import CompaniesComponent from './components/companies.component'
import ProjectsComponent from './components/projects.component'
import BranchesComponent from './components/branches.component'
import RestrictionsComponent from './components/restrictions.component'
import rolesComponent from './components/roles.component'
import WorkflowComponent from './components/workflow.component'
import PermissionsComponent from './components/permissions.component'
import substitutesComponent from './components/substitutes.component'
import SubscriptionsComponent from './components/subscriptions.component'
import historyComponent from './components/history.component'
import ExpensesApprovedComponent from './components/user.expensesApproved.component'
import expensesValidateComponent from './components/expensesValidate.component'
import EmployerReportComponent from './components/employerReport.component'
import ReportsTypeComponent from './components/reportstype.component'
import ReportsByConceptComponent from './components/reportsbyconcept.component'
import NotificationsComponent from './components/notifications.component'
import ExpenseDetailEmployeeComponent from './components/expenseDetailEmployee.component'
import expensesRejectedComponent from './components/user.expensesRejected.component'
import missingReserveExpensesComponent from './components/missingReserveExpenses.component'
import KeywordsComponent from './components/keywords.component'
import SatXMLDownloadComponent from './components/satXMLDownload.component'
import AnnualExpensesReportComponent from './components/annualExpensesReport.component'
import ReportAnnualExpensesBranchComponent from './components/reportAnnualExpensesBranch.component'
import ReportExpensesCategoryBranchComponent from './components/reportExpensesCategoryBranch.component'
import ReportComparativeComponent from './components/reportComparative.component'
import ReportExpenseTrackingComponent from './components/reportExpenseTracking.component'
import ExpensesPayableComponent from './components/expensesPayable.component'
import AnnualExpensesByEmployedReportComponent from './components/annualExpensesByEmployedReport.component'
import expensesPaidComponent from './components/expensesPaid.component'
import wizardComponent from './components/wizard.component'
import adminDashboardComponent from './components/adminDashboard.component'
import advancesComponent from './components/advances.component'
import contactComponent from './components/contact.component'
import pettyCashComponent from './components/pettyCash.component'
import requestPettyCashComponent from './components/requestPettyCash.component'
import amexCardComponent from './components/amexCard.component'
import verifyEFOSComponent from './components/verifyEFOS.component'
import attachFilesComponent from './components/attachFiles.component'
import reservationsComponent from './components/reservations.component'
import viaticRequestComponent from './components/viaticRequest.component'
import cashierComponent from './components/cashier.component'
import representativesComponent from './components/representatives.component.vue'
import generalSearchComponent from './components/generalSearch.component.vue'
import advancesRequestComponent from './components/advancesRequest.component.vue'

import Notifications from 'vue-notification'
import es from 'vuetify/es5/locale/es'
import en from 'vuetify/es5/locale/en'
import showNotification from './plugins/notifications'
import ZoomOnHover from 'vue-zoom-on-hover'
import reportDate from './plugins/reportDate'
import forceFileDownload from './plugins/forceFileDownload'
import sendToPrint from './plugins/sendToPrint'
import PageTitle from './Layout/Components/PageTitle.vue'
import './plugins/filters'
import helpDrawer from './Layout/Components/HelpDrawer.vue'

import Default from './Layout/Wrappers/baseLayout.vue'
import Pages from './Layout/Wrappers/pagesLayout.vue'
import Apps from './Layout/Wrappers/appLayout.vue'

Vue.config.productionTip = false

// Theme configuration, if in use remove the Vue.use(Vuetify) line
// Vue.use(Vuetify, {
//   theme: {
//     primary: '#3f51b5',
//     secondary: '#b0bec5',
//     accent: '#8c9eff',
//     error: '#b71c1c'
//   }
// })

Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(Vuetify, {
  lang: {
    locales: { es, en },
    current: 'es'
  },
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    primary: '#1e3c72',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})
Vue.use(showNotification)
Vue.use(ZoomOnHover)
Vue.use(reportDate)
Vue.use(forceFileDownload)
Vue.use(sendToPrint)

Vue.component('pulse-loader', PulseLoader)

Vue.component('loginComponent', LoginComponent)
Vue.component('forgotPasswordComponent', ForgotPasswordComponent)
Vue.component('usersComponent', UsersComponent)
Vue.component('userApplicationComponent', UserApplicationComponent)
Vue.component('expensesComponent', ExpensesComponent)
Vue.component('expenseItemComponent', ExpenseItemComponent)
Vue.component('expenseTrackingItemComponent', ExpenseTrackingItemComponent)
Vue.component('categoriesComponent', CategoriesComponent)
Vue.component('travelTypesComponent', TravelTypesComponent)
Vue.component('areasComponent', AreasComponent)
Vue.component('toReconcileExpensesComponent', ToReconcileExpensesComponent)
Vue.component('reconciledExpensesComponent', ReconciledExpensesComponent)
Vue.component('missingExpensesComponent', MissingExpensesComponent)
Vue.component('excludedExpensesComponent', ExcludedExpensesComponent)
Vue.component('settingsComponent', SettingsComponent)
Vue.component('validatorsComponent', ValidatorsComponent)
Vue.component('approverComponent', ApproverComponent)
Vue.component('companiesComponent', CompaniesComponent)
Vue.component('projectsComponent', ProjectsComponent)
Vue.component('branchesComponent', BranchesComponent)
Vue.component('restrictionsComponent', RestrictionsComponent)
Vue.component('rolesComponent', rolesComponent)
Vue.component('workflowComponent', WorkflowComponent)
Vue.component('PermissionsComponent', PermissionsComponent)
Vue.component('substitutesComponent', substitutesComponent)
Vue.component('subscriptionsComponent', SubscriptionsComponent)
Vue.component('historyComponent', historyComponent)
Vue.component('expensesApprovedComponent', ExpensesApprovedComponent)
Vue.component('expensesValidateComponent', expensesValidateComponent)
Vue.component('employerReportComponent', EmployerReportComponent)
Vue.component('reportsTypeComponent', ReportsTypeComponent)
Vue.component('notificationsComponent', NotificationsComponent)
Vue.component('expenseDetailEmployeeComponent', ExpenseDetailEmployeeComponent)
Vue.component('expensesRejectedComponent', expensesRejectedComponent)
Vue.component('missingReserveExpensesComponent', missingReserveExpensesComponent)
Vue.component('satXMLDownloadComponent', SatXMLDownloadComponent)
Vue.component('keywordsComponent', KeywordsComponent)
Vue.component('annualExpensesReportComponent', AnnualExpensesReportComponent)
Vue.component('reportAnnualExpensesBranchComponent', ReportAnnualExpensesBranchComponent)
Vue.component('reportExpensesCategoryBranchComponent', ReportExpensesCategoryBranchComponent)
Vue.component('reportsByConceptComponent', ReportsByConceptComponent)
Vue.component('reportComparativeComponent', ReportComparativeComponent)
Vue.component('reportExpenseTrackingComponent', ReportExpenseTrackingComponent)
Vue.component('expensesPayableComponent', ExpensesPayableComponent)
Vue.component('annualExpensesByEmployedReportComponent', AnnualExpensesByEmployedReportComponent)
Vue.component('expensesPaidComponent', expensesPaidComponent)
Vue.component('wizardComponent', wizardComponent)
Vue.component('adminDashboardComponent', adminDashboardComponent)
Vue.component('advancesComponent', advancesComponent)
Vue.component('contactComponent', contactComponent)
Vue.component('pettyCashComponent', pettyCashComponent)
Vue.component('requestPettyCashComponent', requestPettyCashComponent)
Vue.component('amexCardComponent', amexCardComponent)
Vue.component('verifyEFOSComponent', verifyEFOSComponent)
Vue.component('attachFilesComponent', attachFilesComponent)
Vue.component('reservationsComponent', reservationsComponent)
Vue.component('viaticRequestComponent', viaticRequestComponent)
Vue.component('cashierComponent', cashierComponent)
Vue.component('representativesComponent', representativesComponent)
Vue.component('generalSearchComponent', generalSearchComponent)
Vue.component('advancesRequestComponent', advancesRequestComponent)

Vue.component('default-layout', Default)
Vue.component('userpages-layout', Pages)
Vue.component('apps-layout', Apps)
Vue.component('page-title', PageTitle)
Vue.component('HelpDrawer', helpDrawer)

Object.defineProperty(Vue.prototype, '$validationRules', { value: validationRules })

Object.defineProperty(Vue.prototype, '$searchCountry', { value: searchCountry })

Vue.use(Notifications)

export const http = Axios.create({
  baseURL: process.env.HOST
})
export const httpgst = Axios.create({
  baseURL: process.env.HOST_GST
})
export const httpgstgzip = Axios.create({
  baseURL: process.env.HOST_GST,
  transformRequest: Axios.defaults.transformRequest.concat(
    /**
     * Compresión del request body con gzip usando pako
     *
     * https://medium.com/axiomzenteam/put-your-http-requests-on-a-diet-3e1e52333014
     */
    function (data, headers) {
      // compress strings if over 1KB
      if (typeof data === 'string' && data.length > 1024) {
        headers['Content-Encoding'] = 'gzip';
        return pako.gzip(data);
      } else {
        // delete is slow apparently, faster to set to undefined
        headers['Content-Encoding'] = undefined;
        return data;
      }
    }
  )
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js